<h2 mat-dialog-title>{{ data.survey.title }}</h2>

<mat-dialog-content>
  @if (data.survey.description) {
    <p class="text-muted">{{ data.survey.description }}</p>
  }

  <ul class="list-unstyled mb-0">
    @if (data.survey.status) {
      <li class="mb-1">
        <strong>{{ 'generic.status' | translate }}:</strong>
        {{ data.survey.status }}
      </li>
    }
    <li class="mb-1">
      <strong>{{ 'generic.questions' | translate }}:</strong>
      {{ data.survey.questions_count || 0 }}
    </li>
    <li class="mb-1">
      <strong>{{ 'generic.participants' | translate }}:</strong>
      {{ data.survey.members_count || 0 }}
    </li>
    <li class="mb-1">
      <strong>{{ 'generic.responses' | translate }}:</strong>
      {{ data.survey.responses_count || 0 }}
    </li>
    <li class="mb-1">
      <strong>{{ 'generic.responses' | translate }} {{ 'generic.missing' | translate }}:</strong>
      {{ data.survey.pending_count || 0 }}
    </li>
    <li class="mb-1">
      <strong>{{ 'generic.answers.draft' | translate }}:</strong>
      {{ data.survey.drafts_count || 0 }}
    </li>
    <li class="mb-1">
      <strong>{{ 'generic.attachments' | translate }}:</strong>
      {{ data.survey.attachments_count || 0 }}
    </li>
    @if (data.survey.attachments_count) {
      <li class="mb-1 text-muted small">
        {{ data.survey.attachments_completed || 0 }} {{ 'generic.done' | translate }} ·
        {{ data.survey.attachments_waiting || 0 }} {{ 'generic.pending' | translate }} ·
        {{ data.survey.attachments_processing || 0 }} {{ 'components.statement-generator.generations-list.status-processing' | translate }} ·
        {{ data.survey.attachments_failed || 0 }} {{ 'components.statement-generator.generations-list.status-failed' | translate }}
      </li>
    }
    <li>
      <strong>AI Analysis:</strong>
      {{ data.survey.ai_analysis_completed || 0 }} / {{ data.survey.ai_analysis_total || 0 }}
    </li>
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="close()">
    <mat-icon>check</mat-icon>
    {{ 'generic.buttons.close' | translate }}
  </button>
</mat-dialog-actions>
